/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import routes from '../../common/constants/RouteConstants';
import {
  forgotPassword,
  resetErrorMessage,
  setUsername,
} from '../../store/routines';
import forgotPwConfirmation from '../../styles/images/forgot-pw-confirmation.svg';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';
import { formatUserName } from '../../common/util/EmailUtils';
import { cognitoLoginErrorMessageFormatter } from '../../common/util/authUtils';

function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const history = useHistory();

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isForgotPasswordError);
  const isSuccess = useSelector((state) => state.auth.isSuccess);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const displaySuccessMessage = useSelector(
    (state) => state.auth.displaySuccessMessage
  );

  const onForgotPasswordFinish = (values) => {
    const { username } = values;
    const formattedUserName = formatUserName(username);
    dispatch(setUsername({ username: formattedUserName }));
    dispatch(forgotPassword({ username: formattedUserName }));
  };

  const resetForm = () => {
    history.push(routes.loginManagement.login);
  };

  useEffect(() => {
    return () => {
      dispatch(resetErrorMessage());
    };
  }, []);

  const handleBackToLogin = () => {
    history.push(routes.loginManagement.login);
  };

  if (isSuccess && !isLoading && displaySuccessMessage) {
    return (
      <>
        <div className="title smaller">Recovery email is on the way!</div>
        <img
          className="login-status-img"
          src={forgotPwConfirmation}
          alt="Lady mad at you for forgetting your password"
        />
        <div className="subtitle center">
          Check your inbox for instructions on how to reset your account. Be
          sure to check your spam folder too!
        </div>
        <div className="floating-login-footer">
          <a className="request-new-pw" onClick={resetForm}>
            Back to Log in
          </a>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="login-input-wrapper">
        <div className="title smaller">Forgot your password?</div>
        <div className="subtitle">
          Don’t worry! We’ll send you a link with instructions to reset your
          password.
        </div>
        <Form
          name="login_step_1"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onForgotPasswordFinish}
        >
          {isError && errorMessage && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />{' '}
              {errorMessage === 'Incorrect username or password'
                ? 'Incorrect username'
                : cognitoLoginErrorMessageFormatter(errorMessage)}
            </div>
          )}

          <Form.Item
            name="username"
            label="Email"
            className="login-field"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage message="Please enter your username" />
                ),
              },
            ]}
          >
            <Input
              className="login-field"
              placeholder="Enter your email address"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="floating-login-footer">
        Remember your password?{' '}
        <a className="request-new-pw" onClick={handleBackToLogin}>
          Back to Log in
        </a>
      </div>
    </>
  );
}
export default ForgotPasswordForm;
